import React, { useEffect } from "react";
import {
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import { ExpandMoreOutlined } from "@mui/icons-material";
import ActiveFilterIndicator from "./ActiveFilterIndicator";

function SearchOptionGroup({
  id,
  title,
  value,
  setValue,
  customFalseLabel,
  customTrueLabel,
  updateFilter,
  isActive,
}) {
  const handleOnChangeRadioBtn = (val) => {
    setValue(id, val);
    updateFilter(id, val);
  };



  return (
    <>
      <Accordion className="w-full bg-white">
        <AccordionSummary
          className="text-sm"
          expandIcon={
            <div className="flex items-center">
              <ExpandMoreOutlined />
            </div>
          }
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <span className="text-black pr-2">{title}</span>

          <div>
            {!value ? (
              ""
            ) : (
              <div className="flex flex-row items-center">
                <span>&mdash;</span>
                <span className="text-xs text-sky-600 mr-2">&nbsp;{value}</span>
                <span> {isActive && <ActiveFilterIndicator />}</span>
              </div>
            )}
          </div>
        </AccordionSummary>
        <AccordionDetails className="w-full flex justify-between items-start bg-white">
          <FormControl size="small">
            <RadioGroup
              className="text-sm bg-white"
              name="radio-buttons-group"
              value={value}
              onChange={(e) => {
                handleOnChangeRadioBtn(e.target.value);
              }}
            >
              <FormControlLabel
                value={true}
                control={<Radio />}
                label={customTrueLabel ? customTrueLabel : "True"}
                className="text-sm"
              />
              <FormControlLabel
                value={false}
                control={<Radio />}
                label={customFalseLabel ? customFalseLabel : "False"}
                className="text-sm"
              />
            </RadioGroup>
          </FormControl>
          <Button
            onClick={() => handleOnChangeRadioBtn(null)}
            variant="outlined"
            className="text-sm text-red-600 border-red-600 hover:bg-red-600 hover:text-white"
          >
            Clear Filter
          </Button>
        </AccordionDetails>
      </Accordion>
    </>
  );
}

export default SearchOptionGroup;
